import ApiService from '@/common/api.service';

const url = '/v1/subjects';

const SubjectService = {
  activeFilters: 3, // Defaulft active: sort, reversed, page
  query(filters, params = { 'filter[type]': 'residence' }) {
    filters = Object.assign({}, filters);
    const keys = Object.keys(filters);
    const length = keys.length;

    if (this.activeFilters !== length) {
      filters['page'] = 1;
    }

    keys.sort().forEach(key => {
      params[key] = filters[key].value;
    });

    this.activeFilters = length;
    return ApiService.query(url, { params: params });
  },
  get(id) {
    return ApiService.get(url, id);
  },
  save(id = null, subject) {
    if (!id) {
      return ApiService.post(url, subject);
    }
    return ApiService.update(url, id, subject);
  },
  owner(id, contact_id) {
    return ApiService.post(`${url}/${id}/owner`, {
      contact_id: contact_id
    });
  },
  client(id, client_id) {
    return ApiService.post(`/v1/orders/${id}/client`, {
      contact_id: client_id
    });
  },
  saveSource(subjectId, source) {
    const route = `${url}/${subjectId}/sources`;
    if (!source.id) {
      return ApiService.post(route, [source]);
    }
    return ApiService.put(route, [source]);
  }
};

export default SubjectService;
